/** The 409 `code` the API sends when the member already holds an Active per-visit account. */
export const PER_VISIT_ACCOUNT_EXISTS = "PerVisitAccountExists";
